import { render, staticRenderFns } from "./ColonyDelete.vue?vue&type=template&id=8bbcb412&scoped=true&"
import script from "./ColonyDelete.vue?vue&type=script&lang=js&"
export * from "./ColonyDelete.vue?vue&type=script&lang=js&"
import style0 from "./ColonyDelete.vue?vue&type=style&index=0&id=8bbcb412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbcb412",
  null
  
)

export default component.exports